import { useContext } from 'react';

import { TimeframeContext } from './context';

export const useNextTimeframe = () => {
  const { onNext } = useContext(TimeframeContext);
  return onNext;
};
